import { Component, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SolToastrService } from "@niceltd/sol/toastr";
import moment from 'moment';
import { CreatableChallenge } from '../challenge.model';
import { ChallengesService } from '../challenges.service';
import { CxoneChallengeCreateComponent } from '../cxone-challenge-create/cxone-challenge-create.component';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cxone-challenge-create-modal',
  templateUrl: './cxone-challenge-create-modal.component.html',
  styleUrl: './cxone-challenge-create-modal.component.scss'
})
export class CxoneChallengeCreateModalComponent {

  allowClose: boolean = true;
  headerTitle: string = this.dialogConfig.data.headerTitle;
  saveLabel: string = this.dialogConfig.data.saveLabel;
  cancelLabel: string = this.dialogConfig.data.cancelLabel;
  isCreating: boolean = false;

  //reference of create form component
  @ViewChild('createForm') createForm: CxoneChallengeCreateComponent;

  constructor(
    private dialogConfig: DynamicDialogConfig,
    private dialogRef: DynamicDialogRef,
    private challengeService: ChallengesService,
    private toastManager: SolToastrService,
    private cvLocalizationService: CVLocalizationService,
  ){}

  isValidForm(): boolean {
    if (!this.createForm?.challengeForm || this.isCreating) {
      return false;
    }
    return this.createForm.challengeForm.valid;
  }

  save() {
    if (!this.createForm.challengeForm.valid || this.isCreating) {
      return;
    }
    this.isCreating = true;
    const schedule = this.createForm.challengeForm.get('schedule').value;
    const metric = this.createForm.challengeForm.get('metric').value;
    const inviteParticipant = this.createForm.challengeForm.get('inviteParticipant').value;
    const startDate = moment(this.createForm.challengeForm.get('startDate').value).format('M/D/YYYY');
    const wagerAmount = this.createForm.challengeForm.get('wagerAmount').value;
    //remove commas and dots from wager amount
    const formattedWagerAmount = wagerAmount.replace(/,/g, '').replace(/\./g, '');
    this.challengeService.createChallenge({
      ruleID: schedule === 'Daily' ? metric.dayRuleId : metric.weekRuleId,
      startDate,
      wager: Number(formattedWagerAmount),
      invitees: inviteParticipant.map(user => Number(user.value))
    }).then((challenge)=> {
      this.challengeService.addChallenge(challenge);
      this.challengeService.updateUserCoins(Number(-formattedWagerAmount));
      this.dialogRef.close();
      this.toastManager.showToaster("success",this.cvLocalizationService.getCachedText("Challenges", "Invite_Successfully", "Invite sent successfully."))
    }).finally(() => {
      this.isCreating = false;
    });
  }

  onDismiss() {
    this.dialogRef.close();
  }
}
